/**
 * Конфигурационные константы
 * @module
 */

/** Проект запущен в режиме разработки */
export const devMode = import.meta.env.DEV

/** Система на KemsuWeb игнорируется */
export const ignoreKemsuWebSystem =
	import.meta.env.VITE_IGNORE_KEMSUWEB_SYSTEM === "true"

const apiUrlPrefixFromLocalStorage = localStorage.getItem("dev.apiUrlPrefix")
const socketApiUrlPrefixFromLocalStorage = localStorage.getItem("dev.socketApiUrlPrefix")

/** Префикс для http-сервисов */
export const apiUrlPrefix: string = apiUrlPrefixFromLocalStorage || import.meta.env.VITE_API_URL_PREFIX || "https://api-next.kemsu.ru/api"

/** Префикс для сервисов на Web-сокетах */
export const socketApiUrl: string = socketApiUrlPrefixFromLocalStorage || import.meta.env.VITE_SOCKET_API_URL_PREFIX || "wss://api-next.kemsu.ru"

/** Время жизни токена в формате, понятном библиотеке `ms` */
export const accessTokenLifetime: string =
	import.meta.env.VITE_ACCESS_TOKEN_LIFETIME || "3m"

/** Версия сборки */
// process.env.PWA_VERSION на сборке заменится строкой с версией (vite define)
export const pwaVersion = process.env.PWA_VERSION

/** Примет значение `true`, если включена симуляция standalone-режима */
export const isSimulateStandalone = localStorage.getItem("dev.simulateStandalone") === "1" || import.meta.env.VITE_SIMULATE_STANDALONE

/* Сервер системы на KemsuWeb */
export const kemsuWebServer = import.meta.env.VITE_USE_NIAIS === 'true' ? "niais" : "xiais"